import React, { memo } from 'react';

import { UiButton } from '@shared/ui';

import cls from '../VisualizationBlock.module.css';
import { useEmptyVisualization } from './useEmptyVisualization';

interface EmptyVisualizationProps {
    classes?: string;
}

export const EmptyVisualization = memo(({ classes }: EmptyVisualizationProps) => {
    const { is_customer, onClick, can_show_financial_info } = useEmptyVisualization();

    return (
        <div className={cls.emptyVisualizationWrapper}>
            <div className={cls.emptyWrapper}>
                <div className={cls.emptyVisualization}>
                    {is_customer ? (
                        <>
                            {i18next.t('EmptyVisualization.emptyVisualization.isCustomer.part1')}
                            <br />
                            {i18next.t('EmptyVisualization.emptyVisualization.isCustomer.part2')}
                        </>
                    ) : (
                        <div className={cls.emptyVisualizationContent}>
                            <span>
                                {i18next.t('EmptyVisualization.emptyVisualizationContent.part1')}
                                <br />
                                {i18next.t('EmptyVisualization.emptyVisualizationContent.part2')}
                            </span>
                            {can_show_financial_info && (
                                <UiButton
                                    onClick={onClick}
                                    btnText={i18next.t(
                                        'EmptyVisualization.emptyVisualizationContent.button'
                                    )}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});
